module.exports = __webpack_public_path__ + "img/comodin-001.3f9522fa.svg";